export const statusOptions = [
  { label: "Rented", value: "Rented" },
  { label: "Available", value: "Available" },
  { label: "Reserved", value: "Reserved" },
  { label: "Ready", value: "Ready" },
  { label: "Dirty", value: "Dirty" },
];
